import React from 'react';
export const StickyContext = /*#__PURE__*/React.createContext({
  isVisible: false
});
//# sourceMappingURL=StickyContext.js.map